// export { };

declare var _dx:any;

//插入dx   
export const insertDx=(callback:(_dx:any)=> void)=> {
    let node = document.createElement("script");
    const head = document.head || document.getElementsByTagName("head")[0];
    node.setAttribute('id', 'dx-captcha-script');
    node.async = true;
    node.crossOrigin = "anonymous";
    node.onload = onload;

    function onload() {
        node.onload = null;
        head.removeChild(node);
        callback(_dx);
    }

    node.src = 'https://cdn.dingxiang-inc.com/ctu-group/captcha-ui/index.js';
    head.appendChild(node);
}